// extracted by mini-css-extract-plugin
export default {"infoRow":"Reprice__infoRow--f8nuzVmPFcw_wULCcKkb"};